export enum ErrorReasons {
  ProductNotEnabled,
  RouteNotFound,
  PanoNotFound
}
